module.exports = __webpack_public_path__ + "img/apple.2d5d0cbe.svg";